import { Component, Inject, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { ScorecardDataService } from '../core/data.service';
import { Widget, WidgetType } from '../core/template-definition.model';
import { TranslationKeyMap } from '../scorecard.i18n';
import { CMPS_SCORECARD_WIDGET } from '../scorecard.metadata';
import { CompensationModifier } from '../scorecard.model';

@Component({
    selector: 'cmps-scorecard-compensation-modifier-widget',
    templateUrl: './comp-modifier-widget.component.html',
})
@TakeUntilDestroy()
export class ScCompModifierWidgetComponent implements OnDestroy {
    /** @private */ _compensationModifiers: CompensationModifier[];

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _collapsed: boolean;

    /** @private */ get _isLoadingData(): Observable<boolean> {
        return this._loadingData.asObservable();
    }

    private readonly _loadingData: BehaviorSubject<boolean>;

    public headerColour: string;
    public headerTextColour: string;

    constructor(
        private readonly _dataService: ScorecardDataService,
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */ public _widget: Widget,
    ) {
        this.headerColour = _widget.headerColour;
        this.headerTextColour = _widget.headerTextColour;
        this._loadingData = new BehaviorSubject<boolean>(false);
    }

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<CompensationModifier[]>(
                WidgetType.COMPENSATION_MODIFIERS,
            )
            .pipe(
                tap((data) => {
                    this._compensationModifiers = data || [];
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        //
    }
}
